import { useEffect, useState } from 'react';
import { useSharedDataStore } from '@/stores/sharedDataStore';

export const useSharedData = () => {
  const store = useSharedDataStore();
  const [isInitializing, setIsInitializing] = useState(true);
  const [progress, setProgress] = useState(0);

  // Initialize data on mount with progress tracking
  useEffect(() => {
    const initializeData = async () => {
      try {
        setIsInitializing(true);
        setProgress(0);
        
        // Simulate progress for better UX
        const progressInterval = setInterval(() => {
          setProgress(prev => {
            if (prev >= 90) return prev;
            return prev + Math.random() * 10;
          });
        }, 200);

        await store.refreshAllData();
        
        clearInterval(progressInterval);
        setProgress(100);
        
        // Small delay to show completion
        setTimeout(() => {
          setIsInitializing(false);
        }, 300);
        
      } catch (error) {
        console.error('Failed to initialize shared data:', error);
        setIsInitializing(false);
      }
    };

    initializeData();
  }, []); // Empty dependency array to run only once on mount

  return {
    ...store,
    isInitializing,
    progress
  };
}; 